var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 42.8292C9.36463 43.3355 9.45826 43.9486 9.85834 44.3571C10.2584 44.7656 10.8773 44.88 11.4006 44.6422L18.1696 41.5661C23.8588 38.9807 30.0672 37.798 36.2649 38.0762C36.3385 40.0358 36.4477 41.9945 36.5926 43.9512L36.778 46.4551C36.8904 47.9742 38.6107 48.8233 39.9142 48.0032C45.5719 44.4437 50.4904 39.8572 54.4075 34.4881L55.6539 32.7798C55.993 32.315 55.993 31.6889 55.6539 31.224L54.4075 29.5157C50.4904 24.1466 45.5719 19.5601 39.9142 16.0006C38.6107 15.1805 36.8905 16.0296 36.778 17.5487L36.5926 20.0526C36.4683 21.7322 36.3702 23.4132 36.2983 25.0951H34.5566C24.8581 25.0951 15.9837 30.4648 11.6024 38.9841L9.625 42.8292Z",
    fill: "#2980B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.8f319ae289f3fa800b18a869c41dbbbd.svg";
export { ForwardRef as ReactComponent };